import * as mappers from '../data-layer/mappers'
import * as fragments from '../data-layer/fragments'

export const utilsMainDataLayer = () => {
  return {
    mappers,
    fragments
  }
}
